import { Badge, Box, BoxProps, Flex, Heading, Spacer, Text, useColorModeValue } from '@chakra-ui/react';
import React from 'react';
import useColorTheme from '../../hooks/useColorTheme';

type FeedType = {
    feed: any,
    onFeedTapped: (slug: string) => void;
    props?: BoxProps
}

const Feed = ({ feed, onFeedTapped, props }: FeedType) => {

    const { secondaryTextColor, gray, textColor } = useColorTheme()
    const isLog = feed.frontmatter.isLog === true

    return <Box cursor={'pointer'} display={'flex'} flexFlow={'column'} onClick={() => onFeedTapped(feed.frontmatter.slug)} borderRadius={'lg'} p={'5'} bg={gray} key={feed.id} {...props}>
        <Heading color={textColor} fontSize={'lg'}>{feed.frontmatter.title}</Heading>
        {feed.frontmatter.workDate && <Text as='i' fontSize={'xs'} color={secondaryTextColor}>{feed.frontmatter.place}, {feed.frontmatter.workDate}</Text>}

        <Text noOfLines={isLog ? 2 : 0} pt={'2'} color={secondaryTextColor} fontSize={'sm'}>{feed.excerpt}</Text>

        <Spacer />
        <Flex mt={'4'}>
            {feed.frontmatter.tags.map(tag => <Badge shadow={'lg'} mr={'2'} textColor={'white'} bg={!isLog ? "green.500" : "blue.400"}>{tag}</Badge>)}
        </Flex>

        {isLog && <Text mt={'4'} fontSize={'xs'}>{feed.frontmatter.date}</Text>}
    </Box>
};

export default Feed;
